import PreparatoryQuickEntryPage from './_PreparatoryQuickEntryPage'

export default function BreakerDFQuickEntryPage() {
  return <PreparatoryQuickEntryPage kind="breaker-df" />
}
